import { ReactElement } from 'react';
import { Wrapper } from '@components/common/Wrapper/wrapper';
import { MeetingModuleCard } from '../meeting-card/meeting-card';
import { useInfiniteScroll } from '@components/common';
import { GetMeetings } from '../getMeetings/get-meetings';
import { NoDataFound } from '@components/common/no-data-found/noDataFound';
import { useMeetingFilterStore } from '@store/meetingFilterStore';
import { useMeetingListRBDM } from '@services/hooks/meetings/useMeetingListRBDM';
import { useRbdmMeetCompare } from '@services/hooks/meetings/useMeetCompare';
import { useUserRoleType } from '@hooks/useUserRoleType';
import { useRbdmMeetCompareStore } from '@store/rbdmMeetCompareStore';

export const ScheduledMeetingList = (): ReactElement => {
	const { isFetching: queryFetch, error } = useMeetingListRBDM();
	const { scheduledMeetingFilter } = useMeetingFilterStore();
	const { fetchMore, isFetching, result } = GetMeetings({
		...scheduledMeetingFilter,
		type: 'Scheduled Meeting',
	});
	const isRBDM = useUserRoleType();
	const isRBDMMeetCompare = isRBDM === 'RBDM';

	// Call the hook to fetch data and store in Redux (pass selected MDI code)
	const selectedMdicode =
		scheduledMeetingFilter.mdicode && scheduledMeetingFilter.mdicode.trim() !== ''
			? scheduledMeetingFilter.mdicode
			: undefined;
	useRbdmMeetCompare(isRBDMMeetCompare, selectedMdicode);

	// Get data from Redux store
	const { meetCompareData } = useRbdmMeetCompareStore();
	useInfiniteScroll(fetchMore);

	return (
		<Wrapper isLoaderVisible={queryFetch || (isFetching && result.length === 0)} isError={error}>
			<>
				<div>
					{isRBDMMeetCompare && (
						<div className="rbdm-meet-compare-wrapper">
							<p>
								FCC Meets Planned: <b> {meetCompareData?.Scheduled_Meeting ?? 0}</b>{' '}
							</p>
							<p>
								Completed: <b>{meetCompareData?.['Completed Meeting'] ?? 0} </b>{' '}
							</p>
						</div>
					)}
				</div>
				<ul className="meeting-card-wrapper row">
					{result.length > 0 ? (
						result.map((meeting) => {
							return <MeetingModuleCard key={meeting.id} data={meeting} />;
						})
					) : (
						<NoDataFound />
					)}
				</ul>
			</>
		</Wrapper>
	);
};
